import { CachedTranslation } from '@common/types/Translation';
import { TRANSLATIONS_STORAGE_KEY } from '@constants/Translations';

const getCachedTranslations = (): Record<string, CachedTranslation> => {
    try {
        return JSON.parse(sessionStorage.getItem(TRANSLATIONS_STORAGE_KEY) || '{}');
    } catch (error) {
        console.warn('Failed to retrieve cached translations:', error);
        return {};
    }
};

const storeCachedTranslation = (locale: string, etag: string, translations: Record<string, string>) => {
    try {
        const cached = getCachedTranslations();
        cached[locale] = { etag, translations };
        sessionStorage.setItem(TRANSLATIONS_STORAGE_KEY, JSON.stringify(cached));
    } catch (error) {
        console.warn('Failed to store cached translation for locale:', locale, error);
    }
};

const getLocaleFromRegionLocale = (regionLocale: string): string => {
    const parts = regionLocale.split('_');
    return parts?.[0] ?? 'en';
};

const getTranslationFromRegionStrings = (regionStrings: Record<string, string>, locale: string): string => {
    const regionLocales = Object.keys(regionStrings);
    const matchingRegionLocale = regionLocales.find(
        (regionLocale) => getLocaleFromRegionLocale(regionLocale) === locale
    );
    return matchingRegionLocale ? regionStrings[matchingRegionLocale] : regionStrings[regionLocales[0]] || '';
};

export { getCachedTranslations, getLocaleFromRegionLocale, getTranslationFromRegionStrings, storeCachedTranslation };
